//import { General } from './../entities/dossier';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { GenericService } from '../generic.service';
import { Subscription } from 'rxjs/Subscription';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from '../../environments/environment';
import { OnDestroy } from '@angular/core/src/metadata/lifecycle_hooks';
import { AuthService } from '../auth.service';
import { DossierService } from '../dossier.service';
import { Dossier, Experience, Realisation, Skill, Dc, General, Fe, Adm, Actions, Eval, Connaissances, Langue, Adresse, Diplome, Remarques, Certif, Collaborateur, Mission, BilanAnnuel, Developpement, Projet, VieInterne, PerspecEtSouhait, DernierContrat } from '../entities/dossier';
import {Tag} from '../entities/tag';
import * as _ from 'underscore';
import * as loadDash from "lodash";
import {  FileUploader, FileSelectDirective } from 'ng2-file-upload/ng2-file-upload';
import { saveAs } from 'file-saver';
// import { PdfReaderService } from '../pdf-reader.service';
import * as pdfjsLib from 'pdfjs-dist';
import {DomSanitizer, SafeResourceUrl, SafeUrl, Title} from '@angular/platform-browser';
import { FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';
import { NotificationService } from '../notification.service';
import { bind } from 'underscore';




@Component({
  selector: 'app-dossier-details',
  templateUrl: './dossier-details.component.html',
  styleUrls: ['./dossier-details.component.css']
})
export class DossierDetailsComponent implements OnInit {

//Costomier les champs de type texarea avec quill-editor

  public toolbar = [
    
    //[{ header: [1, 2, false] }],
    ['bold', 'italic', 'underline'],   

    [{ 'list': 'ordered'}, { 'list': 'bullet' }],

    [{ 'size': ['small', false, 'large', 'huge'] }],

    [{ 'color': [] }, { 'background': [] }], 
    [{ 'align': [] }],

  ]
  public editorE1Options = {
    placeholder: "Compte rendu E1",
    modules: {
      toolbar: this.toolbar, 
    }
  }
  public editorE2Options = { 
    placeholder: "Compte rendu E2",
    modules: {
      toolbar: this.toolbar,
    }
  }

  public editorE3Options = {
    placeholder: "Réferences",
    modules: {
      toolbar: this.toolbar, 
    }
  }

  public editorE4Options = {
    placeholder: "Connaissances fonctionnelles",
    modules: {
      toolbar: this.toolbar, 
    }
  }

  public editorE5Options = {
    placeholder: "Connaissances techniques",
    modules: {
      toolbar: this.toolbar, 
    }
  }

  public editorE6Options = {
    placeholder: "Souhait",
    modules: {
      toolbar: this.toolbar, 
    }
  }

  public showSpinner : boolean;
  //public errorMessage: string;
  //public successMessage: string;
  public dossier : Dossier;
  public general : General;
  public fe : Fe;
  public actions: Actions;
  public remarques: Remarques;
  public connaissances: Connaissances;
  public adm : Adm;
  public eval : Eval;
  public evals :   Eval[] = [];
  private subscription: Subscription;
  public justUpdated  : String;
  public dcs : Dc[];
  public currentDc : Dc;
  public selectedDC : String;
  public dcClone:Dc;

  //Donner sur le contrat collaborateur
  public isCollaborateur : boolean;
  public newContrat :   Collaborateur
  public erroDateContrat: String = "";
  public collaborateur : Collaborateur[] = [];
  public dernierContrat : DernierContrat;

  public adresse : Adresse;

  // CurrentDC components
  public diplomes : Diplome[] = [];
  public langues : Langue[] = [];
  public skills : Skill[] = [];
  public certifs : Certif[] = [];
  public experiences : Experience[] = [];
  public dskillsTags : Array<Array<any>> = [];
  public titre : String;
  public resume : String;
  public currentExpChecked : boolean = false;
  public coptationIsChecked : Boolean = false;

  public filesToUpload : File[] = [];
  public cvFileToUpload : File[] = [];
  public fileCV : any;
  public file : any;
  public fileType: any
  //afficher par défaut le prénom du Manager connecté dans la liste déroulante
  public defaultManager : string;


  public  MONTION :Array<any> = [
    {label:'tb',display:'Très bien'},
    {label:'b',display:'Bien'},
    {label:'m',display:'Moyen'},
    {label:'mv',display:'Mauvais'},
    ];

//Ajouter le champs statut marital
public  STATUT_MARITAL :Array<any> = [
  {label:'ecsa',display:'En couple sans enfants'},
  {label:'ecae',display:'En couple avec enfants'},
  {label:'cse',display:'Célibataire sans enfants'},
  {label:'cae',display:'Célibataire avec enfants'},
  ];

    public  PAYS :Array<any> = [
      {label:'France',display:'France'},
      {label:'Afghanistan',display:'Afghanistan'},
      {label:'Afrique_Centrale',display:'Afrique Centrale'},
      {label:'Afrique_du_sud',display:'Afrique du sud'},
      {label:'Albanie',display:'Albanie'},
      {label:'Algerie',display:'Algerie'},
      {label:'Allemagne',display:'Allemagne'},
      {label:'Andorre',display:'Andorre'},
      {label:'Angola',display:'Angola'},
      {label:'Anguilla',display:'Anguilla'},
      {label:'Arabie_Saoudite',display:'Arabie Saoudite'},
      {label:'Argentine',display:'Argentine'},
      {label:'Armenie',display:'Armenie'},
      {label:'Australie',display:'Australie'},
      {label:'Autriche',display:'Autriche'},
      {label:'Azerbaidjan',display:'Azerbaidjan'},

      {label:'Bahamas',display:'Bahamas'},
      {label:'Bangladesh',display:'Bangladesh'},
      {label:'Barbade',display:'Barbade'},
      {label:'Bahrein',display:'Bahrein'},
      {label:'Belgique',display:'Belgique'},
      {label:'Belize',display:'Belize'},
      {label:'Benin',display:'Benin'},
      {label:'Bermudes',display:'Bermudes'},
      {label:'Bielorussie',display:'Bielorussie'},
      {label:'Bolivie',display:'Bolivie'},
      {label:'Botswana',display:'Botswana'},
      {label:'Bhoutan',display:'Bhoutan'},
      {label:'Boznie_Herzegovine',display:'Boznie Herzegovine'},
      {label:'Bresil',display:'Bresil'},
      {label:'Brunei',display:'Brunei'},
      {label:'Bulgarie',display:'Bulgarie'},
      {label:'Burkina_Faso',display:'Burkina Faso'},
      {label:'Burundi',display:'Burundi'},

      {label:'Caiman',display:'Caiman'},
      {label:'Cambodge',display:'Cambodge'},
      {label:'Cameroun',display:'Cameroun'},
      {label:'Canada',display:'Canada'},
      {label:'Canaries',display:'Canaries'},
      {label:'Cap_vert',display:'Cap vert'},
      {label:'Chili',display:'Chili'},
      {label:'Chine',display:'Chine'},
      {label:'Chypre',display:'Chypre'},
      {label:'Colombie',display:'Colombie'},

      {label:'Comores',display:'Comores'},
      {label:'Congo',display:'Congo'},
      {label:'Congo_democratique',display:'Congo democratique'},
      {label:'Cook',display:'Cook'},
      {label:'Coree_du_Nord',display:'Coree du Nord'},
      {label:'Coree_du_Sud',display:'Coree du Sud'},
      {label:'Costa_Rica',display:'Costa Rica'},
      {label:'Cote_d_Ivoire',display:'Coted\'Ivoire'},
      {label:'Croatie',display:'Croatie'},
      {label:'Cuba',display:'Cuba'},

      {label:'Danemark',display:'Danemark'},
      {label:'Djibouti',display:'Djibouti'},
      {label:'Dominique',display:'Dominique'},

      {label:'Egypte',display:'Egypte'},
      {label:'Emirats_Arabes_Unis',display:'Emirats Arabes Unis'},
      {label:'Equateur',display:'Equateur'},
      {label:'Erythree',display:'Erythree'},
      {label:'Espagne',display:'Espagne'},
      {label:'Estonie',display:'Estonie'},
      {label:'Etats_Unis',display:'Etats Unis'},
      {label:'Ethiopie',display:'Ethiopie'},
      {label:'Dominique',display:'Dominique'},

      {label:'Falkland',display:'Falkland'},
      {label:'Feroe',display:'Feroe'},
      {label:'Fidji',display:'Fidji'},
      {label:'Finlande',display:'Finlande'},

      {label:'Gabon',display:'Gabon'},
      {label:'Gambie',display:'Gambie'},
      {label:'Georgie',display:'Georgie'},
      {label:'Ghana',display:'Ghana'},
      {label:'Gibraltar',display:'Gibraltar'},
      {label:'Grece',display:'Grece'},
      {label:'Grenade',display:'Grenade'},
      {label:'Groenland',display:'Groenland'},
      {label:'Guadeloupe',display:'Guadeloupe'},
      {label:'Guam',display:'Guam'},
      {label:'Guatemala',display:'Guatemala'},
      {label:'Guernesey',display:'Guernesey'},
      {label:'Guinee',display:'Guinee'},
      {label:'Guinee_Bissau',display:'Guinee Bissau'},
      {label:'Guinee_equatoriale',display:'Guinee equatoriale'},
      {label:'Guyana',display:'Guyana'},
      {label:'Guyane_Francaise',display:'Guyane Francaise'},

      {label:'Haiti',display:'Haiti'},
      {label:'Hawaii',display:'Hawaii'},
      {label:'Honduras',display:'Honduras'},
      {label:'Hong_Kong',display:'Hong Kong'},
      {label:'Hongrie',display:'Hongrie'},

      {label:'Inde',display:'Inde'},
      {label:'Indonesie',display:'Indonesie'},
      {label:'Iran',display:'Iran'},
      {label:'Iraq',display:'Iraq'},
      {label:'Irlande',display:'Irlande'},
      {label:'Islande',display:'Islande'},
      {label:'Israel',display:'Israel'},
      {label:'Italie',display:'Italie'},

      {label:'Jamaique',display:'Jamaique'},
      {label:'Jan_Mayen',display:'Jan Mayen'},
      {label:'Japon',display:'Japon'},
      {label:'Jersey',display:'Jersey'},
      {label:'Jordanie',display:'Jordanie'},

      {label:'Kazakhstan',display:'Kazakhstan'},
      {label:'Kenya',display:'Kenya'},
      {label:'Kirghizstan',display:'Kirghizstan'},
      {label:'Kiribati',display:'Kiribati'},
      {label:'Koweit',display:'Koweit'},

      {label:'Laos',display:'Laos'},
      {label:'Lesotho',display:'Lesotho'},
      {label:'Lettonie',display:'Lettonie'},
      {label:'Liban',display:'Liban'},
      {label:'Liberia',display:'Liberia'},
      {label:'Liechtenstein',display:'Liechtenstein'},
      {label:'Lituanie',display:'Lituanie'},
      {label:'Luxembourg',display:'Luxembourg'},
      {label:'Lybie',display:'Lybie'},

      {label:'Macao',display:'Macao'},
      {label:'Macedoine',display:'Macedoine'},
      {label:'Madagascar',display:'Madagascar'},
      {label:'Madère',display:'Madère'},
      {label:'Malaisie',display:'Malaisie'},
      {label:'Malawi',display:'Malawi'},
      {label:'Maldives',display:'Maldives'},
      {label:'Mali',display:'Mali'},
      {label:'Malte',display:'Malte'},
      {label:'Man',display:'Man'},
      {label:'Mariannes_du_Nord',display:'Mariannes du Nord'},
      {label:'Maroc',display:'Maroc'},
      {label:'Marshall',display:'Marshall'},
      {label:'Martinique',display:'Martinique'},
      {label:'Maurice',display:'Maurice'},
      {label:'Mauritanie',display:'Mauritanie'},
      {label:'Mayotte',display:'Mayotte'},
      {label:'Mexique',display:'Mexique'},
      {label:'Micronesie',display:'Micronesie'},
      {label:'Midway',display:'Midway'},
      {label:'Moldavie',display:'Moldavie'},
      {label:'Monaco',display:'Monaco'},
      {label:'Mongolie',display:'Mongolie'},
      {label:'Montserrat',display:'Montserrat'},
      {label:'Mozambique',display:'Mozambique'},

      {label:'Namibie',display:'Namibie'},
      {label:'Nauru',display:'Nauru'},
      {label:'Nepal',display:'Nepal'},
      {label:'Nicaragua',display:'Nicaragua'},
      {label:'Niger',display:'Niger'},
      {label:'Nigeria',display:'Nigeria'},
      {label:'Niue',display:'Niue'},
      {label:'Norfolk',display:'Norfolk'},
      {label:'Norvege',display:'Norvege'},
      {label:'Nouvelle_Caledonie',display:'Nouvelle Caledonie'},
      {label:'Nouvelle_Zelande',display:'Nouvelle Zelande'},

      {label:'Oman',display:'Oman'},
      {label:'Ouganda',display:'Ouganda'},
      {label:'Ouzbekistan',display:'Ouzbekistan'},

      {label:'Pakistan',display:'Pakistan'},
      {label:'Palau',display:'Palau'},
      {label:'Palestine',display:'Palestine'},
      {label:'Panama',display:'Panama'},
      {label:'Papouasie_Nouvelle_Guinee',display:'Papouasie Nouvelle Guinee'},
      {label:'Paraguay',display:'Paraguay'},
      {label:'Pays_Bas',display:'Pays Bas'},
      {label:'Perou',display:'Perou'},
      {label:'Philippines',display:'Philippines'},
      {label:'Pologne',display:'Pologne'},
      {label:'Polynesie',display:'Polynesie'},
      {label:'Porto_Rico',display:'Porto Rico'},
      {label:'Portugal',display:'Portugal'},

      {label:'Qatar',display:'Qatar'},

      {label:'Republique_Dominicaine',display:'Republique Dominicaine'},
      {label:'Republique_Tcheque',display:'Republique Tcheque'},
      {label:'Reunion',display:'Reunion'},
      {label:'Roumanie',display:'Roumanie'},
      {label:'Royaume_Uni',display:'Royaume Uni'},
      {label:'Russie',display:'Russie'},
      {label:'Rwanda',display:'Rwanda'},

      {label:'Sahara_Occidental',display:'Sahara Occidental'},
      {label:'Sainte_Lucie',display:'Sainte Lucie'},
      {label:'Saint_Marin',display:'Saint Marin'},
      {label:'Salomon',display:'Salomon'},
      {label:'Salvador',display:'Salvador'},
      {label:'Samoa_Occidentales',display:'Samoa Occidentales'},
      {label:'Samoa_Americaine',display:'Samoa Americaine'},
      {label:'Nouvelle_Zelande',display:'Nouvelle Zelande'},
      {label:'Senegal',display:'Senegal'},
      {label:'Seychelles',display:'Seychelles'},
      {label:'Sierra_Leone',display:'Sierra Leone'},
      {label:'Singapour',display:'Singapour'},
      {label:'Slovaquie',display:'Slovaquie'},
      {label:'Slovenie',display:'Slovenie'},
      {label:'Somalie',display:'Somalie'},
      {label:'Soudan',display:'Soudan'},
      {label:'Sri_Lanka',display:'Sri Lanka'},
      {label:'Suede',display:'Suede'},
      {label:'Suisse',display:'Suisse'},
      {label:'Surinam',display:'Surinam'},
      {label:'Swaziland',display:'Swaziland'},
      {label:'Syrie',display:'Syrie'},

      {label:'Tadjikistan',display:'Tadjikistan'},
      {label:'Taiwan',display:'Taiwan'},
      {label:'Tonga',display:'Tonga'},
      {label:'Tanzanie',display:'Tanzanie'},
      {label:'Tchad',display:'Tchad'},
      {label:'Thailande',display:'Thailande'},
      {label:'Tibet',display:'Tibet'},
      {label:'Timor_Oriental',display:'Timor Oriental'},
      {label:'Togo',display:'Togo'},
      {label:'Trinite_et_Tobago',display:'Trinite et Tobago'},
      {label:'Tristan_da_cunha',display:'Tristan da cunha'},
      {label:'Tunisie',display:'Tunisie'},
      {label:'Turkmenistan',display:'Turkmenistan'},
      {label:'Turquie',display:'Turquie'},

      {label:'Ukraine',display:'Ukraine'},
      {label:'Uruguay',display:'Uruguay'},

      {label:'Vanuatu',display:'Vanuatu'},
      {label:'Vatican',display:'Vatican'},
      {label:'Venezuela',display:'Venezuela'},
      {label:'Vierges_Americaines',display:'Vierges Americaines'},
      {label:'Vierges_Britanniques',display:'Vierges Britanniques'},
      {label:'Vietnam',display:'Vietnam'},

      {label:'Wake',display:'Wake'},
      {label:'Wallis_et_Futuma',display:'Wallis et Futuma'},

      {label:'Yemen',display:'Yemen'},
      {label:'Yougoslavie',display:'Yougoslavie'},

      {label:'Zambie',display:'Zambie'},
      {label:'Zimbabwe',display:'Zimbabwe'},
      ];

      public  NATIONNALITE :Array<any> = [
        {label:'FRA',display:'Française (France)'},
        {label:'AFG',display:'Afghane (Afghanistan)'},
        {label:'ALB',display:'Albanaise (Albanie)'},
        {label:'DZA',display:'Algérienne (Algérie)'},
        {label:'DEU',display:'Allemande (Allemagne)'},
        {label:'USA',display:'Americaine (États-Unis)'},
        {label:'AND',display:'Andorrane (Andorre)'},
        {label:'AGO',display:'Angolaise (Andorre)'},
        {label:'ATG',display:'Antiguaise et Barbudienne (Antigua et Barbuda)'},
        {label:'ARG',display:'Argentine (Argentine)'},
        {label:'ARM',display:'Armenienne (Arménie)'},
        {label:'AUS',display:'Australienne (Australie)'},
        {label:'AUT',display:'Autrichienne (Autriche)'},
        {label:'AZE',display:'Azerbaïdjanaise (Azerbaïdjan)'},

        {label:'BHS',display:'Bahamienne (Bahamas)'},
        {label:'BHR',display:'Bahreinienne (Bahreïn)'},
        {label:'BGD',display:'Bangladaise (Bangladesh)'},
        {label:'BRB',display:'Barbadienne (Barbade)'},
        {label:'BEL',display:'Belge (Belgique)'},
        {label:'BLZ',display:'Belizienne (Belize)'},
        {label:'BEN',display:'Béninoise (Bénin)'},
        {label:'BTN',display:'Bhoutanaise (Bhoutan)'},
        {label:'BLR',display:'Biélorusse (Biélorussie)'},
        {label:'MMR',display:'Birmane (Birmanie)'},
        {label:'GNB',display:'Bissau Guinéenne (Guinée Bissau)'},
        {label:'BOL',display:'Bolivienne (Bolivie)'},
        {label:'BIH',display:'Bosnienne (Bosnie Herzégovine)'},
        {label:'BWA',display:'Botswanaise (Botswana)'},
        {label:'BRA',display:'Brésilienne (Brésil)'},
        {label:'GBR',display:'Britannique (Royaume Uni)'},
        {label:'BRN',display:'Brunéienne (Brunéi)'},
        {label:'BGR',display:'Bulgare (Bulgarie)'},
        {label:'BFA',display:'Burkinabée (Burkina)'},
        {label:'BDI',display:'Burundaise (Burundi)'},

        {label:'KHM',display:'Cambodgienne (Cambodge)'},
        {label:'CMR',display:'Camerounaise (Cameroun)'},
        {label:'CAN',display:'Canadienne (Canada)'},
        {label:'CPV',display:'Cap verdienne (Cap Vert)'},
        {label:'CAF',display:'Centrafricaine (Centrafrique)'},
        {label:'CHL',display:'Chilienne (Chili)'},
        {label:'CHN',display:'Chinoise (Chine)'},
        {label:'CYP',display:'Chypriote (Chypre)'},
        {label:'COL',display:'Colombienne (Colombie)'},
        {label:'COM',display:'Comorienne (Comores)'},
        {label:'COG',display:'Congolaise (Congo Brazzaville)'},
        {label:'COD',display:'Congolaise (Congo Kinshasa)'},
        {label:'COK',display:'Cookienne (Îles Cook)'},
        {label:'CRI',display:'Costaricaine (Costa Rica)'},
        {label:'HRV',display:'Croate (Croatie)'},
        {label:'CUB',display:'Cubaine (Cuba)'},

        {label:'DNK',display:'Danoise (Danemark)'},
        {label:'DJI',display:'Djiboutienne (Djibouti)'},
        {label:'DOM',display:'Dominicaine (République dominicaine)'},
        {label:'DMA',display:'Dominiquaise (Dominique)'},

        {label:'EGY',display:'Égyptienne (Égypte)'},
        {label:'ARE',display:'Émirienne (Émirats arabes unis)'},
        {label:'GNQ',display:'Équato guineenne (Guinée équatoriale)'},
        {label:'ECU',display:'Équatorienne (Équateur)'},
        {label:'ERI',display:'Érythréenne (Érythrée)'},
        {label:'ESP',display:'Espagnole (Espagne)'},
        {label:'TLS',display:'Est timoraise (Timor Leste)'},
        {label:'EST',display:'Estonienne (Estonie)'},
        {label:'ETH',display:'Éthiopienne (Éthiopie)'},

        {label:'FJI',display:'Fidjienne (Fidji)'},
        {label:'FIN',display:'Finlandaise (Finlande)'},

        {label:'GAB',display:'Gabonaise (Gabon)'},
        {label:'GMB',display:'Gambienne (Gambie)'},
        {label:'GEO',display:'Georgienne (Géorgie)'},
        {label:'GHA',display:'Ghanéenne (Ghana)'},
        {label:'GRD',display:'Grenadienne (Grenade)'},
        {label:'GTM',display:'Guatémaltèque (Guatemala)'},
        {label:'GIN',display:'Guinéenne (Guinée)'},
        {label:'GUY',display:'Guyanienne (Guyana)'},

        {label:'IND',display:'Indienne (Inde)'},
        {label:'IDN',display:'Indonésienne (Indonésie)'},
        {label:'IRQ',display:'Irakienne (Iraq)'},
        {label:'IRN',display:'Iranienne (Iran)'},
        {label:'IRL',display:'Irlandaise (Irlande)'},
        {label:'ISL',display:'Islandaise (Islande)'},
        {label:'ISR',display:'Israélienne (Israël)'},
        {label:'ITA',display:'Italienne (Italie)'},
        {label:'CIV',display:'Ivoirienne (Côte d\'Ivoire)'},

        {label:'JAM',display:'Jamaïcaine (Jamaïque)'},
        {label:'JPN',display:'Japonaise (Japon)'},
        {label:'JOR',display:'Jordanienne (Jordanie)'},

        {label:'KAZ',display:'Kazakhstanaise (Kazakhstan)'},
        {label:'KEN',display:'Kenyane (Kenya)'},
        {label:'KGZ',display:'Kirghize (Kirghizistan)'},
        {label:'KIR',display:'Kiribatienne (Kiribati)'},
        {label:'KNA',display:'Kittitienne et Névicienne (Saint Christophe et Niévès)'},
        {label:'KWT',display:'Koweïtienne (Koweït)'},

        {label:'LAO',display:'Laotienne (Laos)'},
        {label:'LSO',display:'Lesothane (Lesotho)'},
        {label:'LVA',display:'Lettone (Lettonie)'},
        {label:'LBN',display:'Libanaise (Liban)'},
        {label:'LBR',display:'Libérienne (Libéria)'},
        {label:'LBY',display:'Libyenne (Libye)'},
        {label:'LIE',display:'Liechtensteinoise (Liechtenstein)'},
        {label:'LTU',display:'Lituanienne (Lituanie)'},
        {label:'LUX',display:'Luxembourgeoise (Luxembourg)'},

        {label:'MKD',display:'Macédonienne (Macédoine)'},
        {label:'MYS',display:'Malaisienne (Malaisie)'},
        {label:'MWI',display:'Malawienne (Malawi)'},
        {label:'MDV',display:'Maldivienne (Maldives)'},
        {label:'MDG',display:'Malgache (Madagascar)'},
        {label:'MLI',display:'Maliennes (Mali)'},
        {label:'MLT',display:'Maltaise (Malte)'},
        {label:'MAR',display:'Marocaine (Maroc)'},
        {label:'MHL',display:'Marshallaise (Îles Marshall)'},
        {label:'MUS',display:'Mauricienne (Maurice)'},
        {label:'MRT',display:'Mauritanienne (Mauritanie)'},
        {label:'MEX',display:'Mexicaine (Mexique)'},
        {label:'FSM',display:'Micronésienne (Micronésie)'},
        {label:'MDA',display:'Moldave (Moldovie)'},
        {label:'MCO',display:'Monegasque (Monaco)'},
        {label:'MNG',display:'Mongole (Mongolie)'},
        {label:'MNE',display:'Monténégrine (Monténégro)'},
        {label:'MOZ',display:'Mozambicaine (Mozambique)'},

        {label:'NAM',display:'Namibienne (Namibie)'},
        {label:'NRU',display:'Nauruane (Nauru)'},
        {label:'NLD',display:'Néerlandaise (Pays-Bas)'},
        {label:'NZL',display:'Néo Zélandaise (Nouvelle Zélande)'},
        {label:'NPL',display:'Népalaise (Népal)'},
        {label:'NIC',display:'Nicaraguayenne (Nicaragua)'},
        {label:'NGA',display:'Nigériane (Nigéria)'},
        {label:'NER',display:'Nigérienne (Niger)'},
        {label:'NIU',display:'Niuéenne (Niue)'},
        {label:'PRK',display:'Nord coréenne (Corée du Nord)'},
        {label:'NOR',display:'Norvégienne (Norvège)'},

        {label:'OMN',display:'Omanaise (Oman)'},
        {label:'UGA',display:'Ougandaise (Ouganda)'},
        {label:'UZB',display:'Ouzbéke (Ouzbékistan)'},

        {label:'PAK',display:'Pakistanaise (Pakistan)'},
        {label:'PLW',display:'Palaosienne (Palaos)'},
        {label:'PSE',display:'Palestinienne (Palestine)'},
        {label:'PAN',display:'Panaméenne (Panama)'},
        {label:'PNG',display:'Papouane Néo Guinéenne (Papouasie Nouvelle Guinée)'},
        {label:'PRY',display:'Paraguayenne (Paraguay)'},
        {label:'PER',display:'Péruvienne (Pérou)'},
        {label:'PHL',display:'Philippine (Philippines)'},
        {label:'POL',display:'Polonaise (Pologne)'},
        {label:'PRT',display:'Portugaise (Portugal)'},

        {label:'QAT',display:'Qatarienne (Qatar)'},

        {label:'ROU',display:'Roumaine (Roumanie)'},
        {label:'RUS',display:'Russe (Russie)'},
        {label:'RWA',display:'Rwandaise (Rwanda)'},

        {label:'LCA',display:'Saint Lucienne (Sainte Lucie)'},
        {label:'SMR',display:'Saint Marinaise (Saint Marin)'},
        {label:'VCT',display:'Saint Vincentaise et Grenadine (Saint Vincent et les Grenadines)'},
        {label:'SLB',display:'Salomonaise (Îles Salomon)'},
        {label:'SLV',display:'Salvadorienne (Salvador)'},
        {label:'WSM',display:'Samoane (Samoa)'},
        {label:'STP',display:'Santoméenne (Sao Tomé et Principe)'},
        {label:'SAU',display:'Saoudienne (Arabie saoudite)'},
        {label:'SEN',display:'Sénégalaise (Sénégal)'},
        {label:'SRB',display:'Serbe (Serbie)'},
        {label:'SYC',display:'Seychelloise (Seychelles)'},
        {label:'SLE',display:'Sierra Léonaise (Sierra Leone)'},
        {label:'SGP',display:'Singapourienne (Singapour))'},
        {label:'SVK',display:'Slovaque (Slovaquie)'},
        {label:'SVN',display:'Slovène (Slovénie)'},
        {label:'SOM',display:'Somalienne (Somalie)'},
        {label:'SDN',display:'Soudanaise (Soudan)'},
        {label:'LKA',display:'Sri Lankaise (Sri Lanka)'},
        {label:'ZAF',display:'Sud Africaine (Afrique du Sud)'},
        {label:'KOR',display:'Sud Coréenne (Corée du Sud)'},
        {label:'SSD',display:'Sud Soudanaise (Soudan du Sud)'},
        {label:'SWE',display:'Suédoise (Suède)'},
        {label:'CHE',display:'Suisse (Suisse)'},
        {label:'SUR',display:'Surinamaise (Suriname)'},
        {label:'SWZ',display:'Swazie (Swaziland)'},
        {label:'SYR',display:'Syrienne (Syrie)'},

        {label:'TJK',display:'Tadjike (Tadjikistan)'},
        {label:'TZA',display:'Tanzanienne (Tanzanie)'},
        {label:'TCD',display:'Tchadienne (Tchad)'},
        {label:'CZE',display:'Tchèque (Tchéquie)'},
        {label:'THA',display:'Thaïlandaise (Thaïlande)'},
        {label:'TGO',display:'Togolaise (Togo)'},
        {label:'TON',display:'Tonguienne (Tonga)'},
        {label:'TTO',display:'Trinidadienne (Trinité et Tobago)'},
        {label:'TUN',display:'Tunisienne (Tunisie)'},
        {label:'TKM',display:'Turkmène (Turkménistan)'},
        {label:'TUR',display:'Turque (Turquie)'},
        {label:'TUV',display:'Tuvaluane (Tuvalu)'},

        {label:'UKR',display:'Ukrainienne (Ukraine)'},
        {label:'URY',display:'Uruguayenne (Uruguay)'},

        {label:'VUT',display:'Vanuatuane (Vanuatu)'},
        {label:'VAT',display:'Vaticane (Vatican)'},
        {label:'VEN',display:'Vénézuélienne (Venezuela)'},
        {label:'VNM',display:'Vietnamienne (Viêt Nam)'},

        {label:'YEM',display:'Yéménite (Yémen)'},

        {label:'ZMB',display:'Zambienne (Zambie)'},
        {label:'ZWE',display:'Zimbabwéenne (Zimbabwe)'},
        ];

  public permisChecked : boolean = false;
  public retardChecked : boolean = false;
  public validationChecked : Boolean = false;
  public refChecked : boolean = false;


  public firtNameManager;
  public managers : string[] = [];
  public listDetailconsultants: any[] = [];
  public listDetailAnciensconsultants: any[] = [];

  public allMyCooptations: any[] = [];
  public bodyCooptation ={
    prenomNom: ""
  };
  public sortKey :string;

  //Ranger par defaut dans ordre alphabétique le nom des collaborateurs cooptés
  public order: string = "dateDernierEntretien"; 
  public reverse: boolean = false;
  public config: any;
  

  public justSaved  : String;
  public isValid : any;
  public MsgError  : String;
  public fileContent: string = '';
  public indexOfCopy;
  public temp : String = '';
  public editForm : Boolean = false;
  public url: any;
  public trustedURL: SafeUrl;


  //Stoker le prénom et nom du collaborateur ayant le dossier
  public prenomNomDossier:  String = '';


  //id de l'utilisateur pour l'ajout du dossier en favorite
  public idUser : any;
  public isFavorite: boolean = false;
  public dataFavorite = {
    idManager: "",
    idDossier: "",
    manager: ""
  }

  // variables permettant de stocker une note pour chaque évaluation
  public NotePresen : number = 0;
  public NoteNivTech : number = 0;
  public NoteDyna : number = 0;
  public NoteMotiva : number = 0;
  public NoteGenerale: any = 0;
  public moyenne : any = 0;

   //Variable pour le partage de dossier avec un autre Manager
  sendMailForm: FormGroup
  public sendMailData = {
    idDossier: '',
    managerSend: '',
    message: '',
    managerConnected: ''
  };
  public message: any;
  public managerSend: any

  //VARIABLES PERMETTANT DE TRAITER LE BILAN ANNUEL
  public mission : Mission
  public missions: Mission[] = [];
  public toValidateChecked : Boolean = false;
  public idmission : any;


   //VARIABLES PERMETTANT D'INITIER UN BILAN ANNUEL
   public respectRegleChecked : Boolean = false;
   public plantageChecked : Boolean = false;
   public participationEvenChecked : Boolean = false;
   public OrganisationEvenChecked : Boolean = false;
   public animFormationEvenChecked : Boolean = false;
   public ponctuelChecked : Boolean = false;
   public propositionChecked : Boolean = false;
   public bilanAnnuel : BilanAnnuel;
   public bilansAnnuels : BilanAnnuel[] = [];
   public projet  : Projet;
   public projets : Projet[] = [];
   public vieInterne : VieInterne;
   public developpement : Developpement;
   public perspecEtSouhait : PerspecEtSouhait;
   public perspecEtSouhaits : PerspecEtSouhait[] = [];
   public annee : any;
   public moyenneMissions : any = 0;
   public moyenneMission : any = 0;
   public lengthProjets : number = 0;
   public moyenneTotolBA : number = 0;
   public increhrefDate = new Date();
   public anneeBilan : any;
   public fileToUploadBA : File[] = [];
   public fileBA : any;

 
 
 
   // variables permettant de stocker les valeurs pour le calcul des moyennes missions et vie internes
   public ponctualiteWellD : number = 0;
   public respectRegle : number = 0;
   public plantage  : number = 0;
   public participation  : number = 0;
   public organisation  : number = 0;
   public animationInter : number = 0;
   public proposition : number = 0;
   public animFormation : number = 0;
   public moyenneInterneEtdevelop : number = 0;
 
 
   //Performance lors de l'évaluation des missions du BA d'un collaborateur
   public  PERFORMANCE :Array<any> = [
     {label: 2 ,display:'Bonne'},
     {label: 4 ,display:'Exceptionnelle'},
     {label: 3 ,display:'Très bonne'},
     {label: 1 ,display:'Moyenne'},
     {label: 0 ,display:'Mauvaise'},];
 

  public ListLangue: string[] = ["Anglais","Français","Arabe",  "Allemand",  "Italien", "Chinois"];
  public provenances: string[] = ["LinkedIn", "Monster", "Apec", "France Travail", "HelloWork", "Candidature spontannée"];
  public titlePagecollabo :String;

  constructor(private dossierService: DossierService, public _authService: AuthService,
    private _genericService: GenericService, private _route: ActivatedRoute,
    private sanitizer:DomSanitizer, private _formBuilder: FormBuilder, private _notifyService: NotificationService ,private titlePage : Title ) { }
  ngOnInit() {
    this._authService.checkCredentials();

    this.subscription = this._route
    .queryParams
    .subscribe(
      params => {
        this.init( params)
      }
    );

    this.justUpdated = '';
    this.MsgError = '';
    this.defaultManager = this._authService.getAuthenticatedFirstName();
    this.idUser = this._authService.getAuthenticatedIdUser();
    this.getAllManagers();
    this.getInfoConsultants();
    this.getInfoAnciensConsultants();
    this.dossier = new Dossier();
    this.general = new General();
    this.fe = new Fe();
    this.connaissances = new Connaissances();
    this.adm = new Adm();
    this.actions = new Actions();
    this.remarques = new Remarques();
    this.eval = new Eval();
    this.evals.push(this.eval);                                                
    this.newContrat = new Collaborateur();
    this.collaborateur.push(this.newContrat)
    this.dernierContrat = new DernierContrat();
    this.adresse = new Adresse();
    this.dossier.cvFile = [];
    this.dossier.files = [];
    this.justSaved = '';

    this.mission = new Mission;
    this.missions.push(this.mission);
    this.initFormSend();
    //initialisation du formulaire du bilan annuel   
    this.bilanAnnuel = new BilanAnnuel();
    this.annee = new Date();
    this.bilanAnnuel.annee = this.annee.getFullYear();
    this.projet = new Projet();
    this.bilanAnnuel.projets = this.projets;
    this.bilanAnnuel.projets.push(this.projet);
    this.perspecEtSouhait  = new PerspecEtSouhait()
    this.bilanAnnuel.perspecEtSouhaits = this.perspecEtSouhaits;
    this.bilanAnnuel.perspecEtSouhaits.push(this.perspecEtSouhait);
    this.bilansAnnuels.push(this.bilanAnnuel);

  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();

  }




  //Partager le dossier avec un autre Manager 
  initFormSend(){
    this.sendMailForm = this._formBuilder.group({
      managerSend: ['', Validators.required],
      message: ''
    });
  }

  onSendMail(){
    const formValue = this.sendMailForm.value
    this.sendMailData.idDossier = this._route.snapshot.queryParams.id
    this.sendMailData.managerSend = formValue["managerSend"];
    this.sendMailData.message = formValue["message"];
    this.sendMailData.managerConnected = this._authService.getAuthenticatedFirstName();
    this._genericService.saveResource(environment.shareCandidateFile, this.sendMailData, true, environment.contentTypes.json)
    .subscribe(
      data => {
        this._notifyService.showSuccess("Le dossier à Bien été envoyé", "Send email", 3000)
        /*window.scroll(0,0);
        this.successMessage = "Le dossier à Bien été envoyé";
        this.justSaved = this.successMessage;
        this.resetSuccesMessage();*/
        this.reloadPage()
      },
      error => {
        //this.showSpinner = false;
        this._notifyService.showError("Erreur d'envoie du dossier", "Send email", 3000)
        /*window.scroll(0,0);
        this.errorMessage = "Erreur d'envoie du dossier";
        this.MsgError = error.message;
        this.resetErrorMessage();*/
      }
    );
 }

 //Ajouter un dossier en favorite.
 addFavoriteAction(){
  if (confirm("Voulez vous vraiment ajouter ce dossier de vos favoris ?")) {
    this.dataFavorite.idDossier = this._route.snapshot.queryParams.id;
    this.dataFavorite.idManager = this._authService.getAuthenticatedIdUser();
    this.dataFavorite.manager = this.defaultManager;
    this._genericService.saveResource(environment.addDossierFavorite, this.dataFavorite, true, environment.contentTypes.json)
    .subscribe(
      () => {
        this._notifyService.showSuccess("Dossier ajouté dans mes favoris", "Add Favorite", 3000)
        /*window.scroll(0,0);
        this.successMessage = "Dossier ajouté dans mes favoris";
        this.justUpdated = this.successMessage;
        this.resetSuccesMessage();*/
        this.reloadPage()
      },
      error => {
        //this.showSpinner = false;
        this._notifyService.showError("Erreur lors de l'ajout du dossier en favoris", "Add Favorite", 3000)
        /*window.scroll(0,0);
        this.errorMessage = "Erreur lors de l'ajout du dossier en favoris";
        this.MsgError = error.message;
        this.resetErrorMessage();*/
      }
    );
    
  }
}


//retirer un dossier en favorite
removeFavoriteAction(){
  if (confirm("Voulez vous Vraiment supprimer ce dossier de vos favoris ?")) {
    this.dataFavorite.idDossier = this._route.snapshot.queryParams.id;
    this.dataFavorite.idManager = this._authService.getAuthenticatedIdUser();
    this.dataFavorite.manager = this.defaultManager;

    this._genericService.saveResource(environment.removeDossierFavorite, this.dataFavorite, true, environment.contentTypes.json)
    .subscribe(
      () => {
        this._notifyService.showSuccess("Dossier retiré des favoris", "Remove favorite", 3000)
        /*window.scroll(0,0);
        this.successMessage = "Dossier retiré des favoris";
        this.justUpdated = this.successMessage;
        this.resetSuccesMessage();*/
        this.reloadPage()

      },
      error => {
        //this.showSpinner = false;
        this._notifyService.showSuccess("Erreur lors de la suppression du dossier en favoris", "Remove favorite", 3000)
        /*window.scroll(0,0);
        this.errorMessage = "Erreur lors de la suppression du dossier en favoris";
        this.MsgError = error.message;
        this.resetErrorMessage();*/
      }
    );
  }
}


// récupérer le prénom des utilisateurs ayant le role AMIN ou MANAGER
getAllManagers(){
  this._genericService.getResource(environment.statsTotalManagers, true, 0)
  .subscribe(
    result =>{
      this.firtNameManager = result;
      for (let i = 0; i < this.firtNameManager.length; i++) {
         this.managers.push(this.firtNameManager[i].prenom);
      }    
    },
    error =>{
    }
  );
}
     

//Trier le tableau collaborateurs dans l'ordre alphbétique
SortArray(x: any,y: any){
  return x.collaborateur.localeCompare(y.collaborateur, 'fr', {ignorePunctuation: true});
}

  /**
   * handle event select filles.
   */
  handleFileInput(files: FileList) {
    for(let i=0; i<files.length; i++){
      this.filesToUpload.push(files.item(i));
    }
  }

  /**
  * handle event select CV files
   */
  handleCvFileInput(cvFile: FileList) {
    this.cvFileToUpload[0] = cvFile.item(0);
  }

  /**
  * handle event select files select Bilan annuel
   */
  handleFileInputBA(fileBA: FileList) {
    this.fileToUploadBA[0] = fileBA.item(0);
  }

  init(params) {
    this.showSpinner = true;

    this._genericService.findById(environment.dossierUrl, params['id'], true)
    .subscribe(
      data => {
        //Récupérer le prénom et nom du collaborateur ayant le dossier pour ne pas l'affficher dans le select des provenances
        this.prenomNomDossier = data.general.prenom + ' ' + data.general.nom;
        this.fillDossierInView(data);
        this.saveCurrentDC();
      },
      error => {
        this.showSpinner = false;
        //window.scroll(0,0);
        this._notifyService.showError("Erreur de téléchargement des données", "Dossier", 3000)
        /*this.errorMessage = "Erreur de téléchargement des données";
        this.MsgError = error.message;
       this.resetErrorMessage();*/
      }
     );
  }

  //Récupérer le dossier à afficher
  fillDossierInView(data){
    this.showSpinner = false;
    this.dossier._id = data._id;
    // fill general info
    if(data.general != undefined){
      this.general = data.general;
      this.general.validiteSejour = this.formatDateForDisplay(this.general.validiteSejour);
      this.general.dateNaissance = this.formatDateForDisplay(this.general.dateNaissance);
      this.titlePage.setTitle(this.general.prenom + ' ' + this.general.nom);
    }

    // fill fiche d'entretien info
    if(data.fe.adm != undefined)
      this.adm = data.fe.adm;
    if(data.fe.connaissances != undefined)
      this.connaissances = data.fe.connaissances;
    if(data.fe.actions != undefined){
      this.actions = data.fe.actions;
    }
    if(data.fe.remarques != undefined)
      this.remarques = data.fe.remarques;
    if(data.fe.actions.evals != undefined)
    {
      this.evals = data.fe.actions.evals;
      for(let e of this.evals)
        e.date = this.formatDateForDisplay(e.date);
    }

    //Récupérer les informations sur les contrats
    if(data.collaborateur != undefined && data.collaborateur.length >= 1){
      this.isCollaborateur = true;
      this.collaborateur = data.collaborateur;
      for (let con of this.collaborateur){
        con.dd = this.formatDateForDisplay(con.dd);
        con.df = this.formatDateForDisplay(con.df);
      }
    }

    //Récupérer les informations sur le dernier contrat
    if(data.collaborateur.length >= 1 && data.dernierContrat != undefined){
      this.isCollaborateur = true
      this.dernierContrat = data.dernierContrat;
      this.dernierContrat.dd = this.formatDateForDisplay(this.dernierContrat.dd);
      this.dernierContrat.df = this.formatDateForDisplay(this.dernierContrat.df);
    }

    //Ajouter une nouvelle mission
    if(data.missions != undefined){
      this.missions = data.missions;
      for (let mis of this.missions){
        mis.debutMission = this.formatDateForDisplay(mis.debutMission);
        mis.finMission = this.formatDateForDisplay(mis.finMission);
        mis.dateValidation = this.formatDateForDisplay(mis.dateValidation);
        if(mis.isValidated == true && mis.toValidate == false){ //Rénitialiser la validation de la mission
          mis.isValidated = false; 
        }
      }
    }

    if(data.fe != undefined)
      this.fe = data.fe;
    // fill diplomes & langues
    if(data.diplomes != undefined)
      this.diplomes = data.diplomes;
    if(data.langues != undefined)
      this.langues = data.langues;




    //fill dossier de compétance info
    if(data.dcs != undefined){
      this.dcs = data.dcs;
      if(this.dcs.length > 0){
        let selId = this.selectedDC;
        let selected = _.find(this.dcs, function(d){ return ( d._id == selId);});
        let indexOfSelected = _.findIndex(this.dcs, function(d){ return d._id == selId});

        if(this.selectedDC == undefined){
          this.selectedDC = this.dcs[this.dcs.length -1]._id;
        }
        this.fillCurrentDC();
      }
    }


    //Vérifier si le tableau des favorites existes et qu'il contient déjà l'identifiant de l'utilisateur connecté.
    if(data.favorites != undefined){
      for (let index = 0; index < data.favorites.length; index++) {
        if (data.favorites[index].idManager == this.idUser) {
          this.isFavorite = true;
        }else{
          this.isFavorite = false;
        }
        
      }
    }

    //RECUPERER LA LISTE DES BILANS ANNUELS POUR UN COLLABORATEUR ET FORMATER LA DATE
      if(data.bilansAnnuels != undefined){
        this.bilansAnnuels = data.bilansAnnuels;
      }
    
      if(this.bilansAnnuels.length > 0){
        for(let bilan of this.bilansAnnuels){
          bilan.dateEntreeCdiWelld = this.formatDateForDisplay(bilan.dateEntreeCdiWelld);
          bilan.occupeDepuis = this.formatDateForDisplay(bilan.occupeDepuis);
          bilan.dateEntretien = this.formatDateForDisplay(bilan.dateEntretien);
          for( let souhait of bilan.perspecEtSouhaits){
            souhait.dateDebut = this.formatDateForDisplay(souhait.dateDebut);
          }
        }
      }
    


    if(data.adresse != undefined)
      this.adresse = data.adresse;
    // files
    if(data.files != undefined){
      this.dossier.files = data.files;
    }

    if(data.cvFile != undefined){
      this.dossier.cvFile = data.cvFile;
    }
  }




  //Récupérer le prénom et nom des collaborateurs actuels pour passer dans le champs select
  getInfoConsultants(){
    this._genericService.getResource(environment.statsgetInfoConsultants, true, 0)
    .subscribe(
      data =>{
        for (let i = 0; i < data.length; i++) {
          //Supprimer du select le nom du collaborateur ayant le dossier
          if(data[i].general.prenom + ' ' + data[i].general.nom == this.prenomNomDossier){
            delete data[i];
          }else{
            this.listDetailconsultants.push({
              collaborateur : data[i].general.prenom + ' ' + data[i].general.nom,
            });
          }
      }
      this.listDetailconsultants.sort(this.SortArray)
      },
      error =>{
      }
    )
  }

  //Récupérer le prénom et nom des anciens collaborateurs  pour passer dans le champs select
  getInfoAnciensConsultants(){
    this._genericService.getResource(environment.statsgetInfoAnciensConsultants, true, 0)
    .subscribe(
      data =>{

        for (let i = 0; i < data.length; i++) {
          //Supprimer du select le nom du collaborateur ayant le dossier
          if(data[i].general.prenom + ' ' + data[i].general.nom == this.prenomNomDossier){
            delete data[i];
          }else{
            this.listDetailAnciensconsultants.push({
              collaborateur : data[i].general.prenom + ' ' + data[i].general.nom,
            });
          }
      }
      this.listDetailAnciensconsultants.sort(this.SortArray)
      },
      error =>{
      }
    )
  }
  
  

  //Récupérer l'indentifiant du dossier en cours
  getMyCooptations(){
    this.bodyCooptation.prenomNom = this.general.prenom + ' ' + this.general.nom
    this._genericService.searchConsultantWithBody(environment.statsgetMyCooptations, this.bodyCooptation, true, -1, this.sortKey)
    .subscribe(
      data => {
        //Configuration de la pagination 
        this.config = {
          itemsPerPage: 10,
          currentPage: 1,
          //totalItems: this.listDetailconsultants.length
        };
        for (let i = 0; i < data.length; i++) {
          this.allMyCooptations.push({ 
            prenom: data[i].general.prenom, 
            nom: data[i].general.nom, 
            profil: data[i].general.profil,
            collaborateur: data[i].dernierContrat,
            noteGeneral : data[i].fe.noteGeneral,
            validation: data[i].fe.actions.validation ,
            dateDernierEntretien: data[i].general.dateDernierEntretien,  
            _id: data[i]._id, 
          });
        }
      },
      error => {
      });

  }

  //Ranger les élements du tableau des cooptations selon l'ordre choisi
  setOrder(value: string) {
    if (this.order === value) {
      this.reverse = !this.reverse;
    }

    this.order = value;
  }

  //pagination du tableau des consultants
  pageChanged(event: any){
    this.config.currentPage = event;
  }


  //Mise à jour du dossier
  update(isValid){
    //this.clearMessages();
    if(isValid){
    this.dossier.general = this.general;
    this.dossier.general.nom = this.dossier.general.nom.trim().replace(/-/g, ' ')
      .replace(/á|à|â|ä|a̧|ǎ|ã/gi,"a").replace(/ć|c̀|ĉ|c̈|ç|č|c̃/gi,"c")
      .replace(/é|è|ê|ë|ȩ|ě|ẽ/gi,"e").replace(/í|ì|î|ï|i̧|ǐ|ĩ/gi,"i")
      .replace(/ó|ò|ô|ö|o̧|ǒ|õ/gi, "o").replace(/ú|ù|û|ü|u̧|ǔ|ũ/gi,"u").replace(/  +/g, ' ')
      .toUpperCase();

      let prenom = this.dossier.general.prenom.trim().replace(/-/g, ' ')
      .replace(/á|à|â|ä|a̧|ǎ|ã/gi,"a").replace(/ć|c̀|ĉ|c̈|ç|č|c̃/gi,"c")
      .replace(/é|è|ê|ë|ȩ|ě|ẽ/gi,"e").replace(/í|ì|î|ï|i̧|ǐ|ĩ/gi,"i")
      .replace(/ó|ò|ô|ö|o̧|ǒ|õ/gi, "o").replace(/ú|ù|û|ü|u̧|ǔ|ũ/gi,"u").replace(/  +/g, ' ').split(' ');

      let pp="";
      for(let i=0 ; i < prenom.length ; i++ ) {
        let lettreUn = prenom[i][0].toUpperCase();
        let resteMot = prenom[i].substring(1).toLowerCase();
        pp= pp + lettreUn + resteMot+' ';

      }
      this.dossier.general.prenom = pp.trim();

      this.dossier.general.email = this.dossier.general.email.trim().toLowerCase();

       // CALCULER LA MOYENNE POUR CHAQUE EVALUATION AINSI QUE LA NOTE GENERALE
       if (this.evals.length > 0) {
        for (let i = 0; i < this.evals.length; i++) {
          if(this.evals[i].presentation == "tb") this.NotePresen = 100; if(this.evals[i].presentation == "b") this.NotePresen = 75;
          if(this.evals[i].presentation == "m") this.NotePresen = 50;if (this.evals[i].presentation == "mv") this.NotePresen = 25;
          if(this.evals[i].dynamisme == "tb") this.NoteDyna = 100; if(this.evals[i].dynamisme == "b") this.NoteDyna = 75;
          if(this.evals[i].dynamisme == "m") this.NoteDyna = 50; if(this.evals[i].dynamisme == "mv") this.NoteDyna = 25; 
          if(this.evals[i].nivTech == "tb") this.NoteNivTech = 100; if(this.evals[i].nivTech == "b") this.NoteNivTech = 75;
          if(this.evals[i].nivTech == "m") this.NoteNivTech = 50; if(this.evals[i].nivTech == "mv") this.NoteNivTech = 25;
          if(this.evals[i].motivation == "tb") this.NoteMotiva = 100; if(this.evals[i].motivation == "b") this.NoteMotiva = 75;
          if(this.evals[i].motivation == "m") this.NoteMotiva = 50; if(this.evals[i].motivation == "mv") this.NoteMotiva = 25;
     this.moyenne = (this.NotePresen + this.NoteDyna + this.NoteNivTech + this.NoteMotiva) / 4
     this.evals[i].moyenne = parseInt(this.moyenne)

     }
       }
    // calculer la note génerale des évaluations
    for (let index = 0; index < this.evals.length; index++) {
      this.NoteGenerale += this.evals[index].moyenne 
    }
    this.NoteGenerale = (this.NoteGenerale / this.evals.length)
    // passer la note générale du candidat à 0% si la candidature est "non validée"
    if (this.fe.actions.validation == true) {
      this.fe.noteGeneral = 0;
    } else {
    this.fe.noteGeneral = parseInt(this.NoteGenerale)
    }



    //CALCULER LA MOYENNE D'UNE MISSION DANS UN BILAN ANNUEL
        for(let bilan of this.bilansAnnuels){
          for(let projet of bilan.projets){
            projet.moyenneMission = (projet.objectifAtteint + projet.integrationEtSavoir + projet.rapiditeAcquisition + projet.priseInitiative + projet.communicationEtLibrable );
            this.moyenneMission = projet.moyenneMission;
          }
        }

    //CALCULER LA MOYENNE DE VIE INTERNE DANS UN BILAN ANNUEL
    for(let bilan of this.bilansAnnuels){
      if(bilan){
        if(bilan.vieInterne != undefined){
          if(bilan.vieInterne.ponctualite != undefined) this.ponctualiteWellD = bilan.vieInterne.ponctualite;
          if(bilan.vieInterne.respectRegle == true) this.respectRegle = 1;
          if(bilan.vieInterne.plantage == true) this.plantage = -1;
          if(bilan.vieInterne.participationEven == true) this.participation = 1;
          if(bilan.vieInterne.OrganisationEven == true) this.organisation = 1;
        }
        if(bilan.developpement != undefined){
          if(bilan.developpement.animFormation == true) this.animFormation = 1;
          if(bilan.developpement.proposition != undefined) this.proposition = bilan.developpement.proposition;
        }
              
      this.moyenneInterneEtdevelop = (this.ponctualiteWellD + this.respectRegle + this.plantage + this.participation + this.organisation + this.animFormation + this.proposition);
      bilan.moyenneVieInterneEtdevelop = this.moyenneInterneEtdevelop;
      this.ponctualiteWellD = 0;
      this.respectRegle =0;
      this.plantage = 0;
      this.participation = 0;
      this.organisation = 0;
      this.animFormation = 0;
      this.proposition = 0;
      this.moyenneInterneEtdevelop = 0;
      }
    }
        

    //CALCULER LA MOYENNE TOTAL DES MISSIONS DANS UN BILAN ANNUEL
    for(let bilan of this.bilansAnnuels){
      let length : number = 0;
      this.lengthProjets = length;
      this.lengthProjets  = bilan.projets.length;
      if(bilan.projets.length > 0){
        for(let index = 0; index < bilan.projets.length; index++ ){
          this.moyenneMissions += bilan.projets[index].moyenneMission;
        }
      }
      this.moyenneMissions = this.moyenneMissions / this.lengthProjets;
      bilan.moyenneMissions = parseInt(this.moyenneMissions);
      this.moyenneMissions = 0;

    }   

    //CALCULER LA MOYENNE TOTAL DU BILAN ANNUEL
    for(let bilan of this.bilansAnnuels){
      this.moyenneTotolBA = (bilan.moyenneMissions + bilan.moyenneVieInterneEtdevelop)
      bilan.moyenneTotalBA = this.moyenneTotolBA;
      this.moyenneTotolBA = 0;
    }
      

    //ATTRIBUER CHAQUE CHAMPS DU DOSSIER LES NOUVELLES MODIFICATIONS POUR FAIRE LA MISE A JOUR.  
    this.fe.adm = this.adm;
    this.fe.actions = this.actions;
    this.fe.connaissances = this.connaissances;
    this.fe.remarques = this.remarques;
    this.actions.evals = this.evals;
    if(this.fe.details){
      this.fe.details.trim();
      if(this.fe.provenance == "Cooptation interne" && this.fe.coptationIsValided == false){
        delete this.fe.coptationIsValided;
      }
      if(this.fe.provenance == "Cooptation externe" && this.fe.coptationIsValided == false){
        delete this.fe.coptationIsValided;
      }
    }
    this.dossier.fe = this.fe;
    this.dossier.langues = this.langues;
    this.dossier.diplomes = this.diplomes;
    
    if(this.isCollaborateur && this.missions.length > 0){
      this.dossier.missions = this.missions;
    }

    if(this.isCollaborateur && this.collaborateur.length == 0){
      this.dossier.collaborateur = this.collaborateur;
      this.dossier.dernierContrat = this.collaborateur[this.collaborateur.length - 1];
    }
    if(this.isCollaborateur && this.collaborateur.length >= 1){
      if(this.collaborateur[this.collaborateur.length - 1].df == undefined || this.collaborateur[this.collaborateur.length -1 ].df == null ){
        this.collaborateur[this.collaborateur.length - 1].fonction = 'COLLABORATEUR';
      }else{
        this.collaborateur[this.collaborateur.length - 1].fonction = 'ANCIEN COLLABORATEUR';
      }
      this.dossier.collaborateur = this.collaborateur;

      //Récupérer le dernier enregistrement des contrats
      this.dossier.dernierContrat = this.collaborateur[this.collaborateur.length - 1];
    }
    if(this.isCollaborateur && this.bilansAnnuels.length > 0){
      this.dossier.bilansAnnuels = this.bilansAnnuels;
    }

    this.dossier.general.dateDernierEntretien = this.dossier.fe.actions.evals.map(o=>o.date).reduce((a, b)=> { return a > b ? a : b; });
 
    this.dossier.adresse = this.adresse;
    if(this.dcs != undefined)
      this.dossier.dcs = this.dcs;
    // Mettre à jour le dossier selectionné
    this.saveCurrentDC();
    // Mise à jour du dossier

    this.showSpinner = true;
    // récupérer une ressource
    this._genericService.saveResource(environment.updateDssier, this.dossier, true, environment.contentTypes.json)
      .subscribe(
        data => {
          let d1: any;
          let d2: any;
          //variable pour vérifier les dates des nouveaux contrats
          let date1: any;
          let date2: any;
          let date3: any;
          let date4: any

          let selId = this.selectedDC;
          let indexOfSelected = _.findIndex(this.dcs, function(d){ return d._id == selId});
          // initialiser les variables Moyenne et Note génerale
          this.NoteGenerale = 0;
          this.moyenne = 0;
          if(data.general.dateDernierEntretien == undefined){
            data.general.dateDernierEntretien = this.dossier.general.dateDernierEntretien;
          }

          //vérifier la valeur des dates pour les nouveaux contrats
          /*if(data.collaborateur.length && data.collaborateur.length == 1){
            if( data.collaborateur[0].dd > data.collaborateur[0].df && (data.collaborateur[0].df != undefined || data.collaborateur[0].df != null)){
              this.temp = this.temp+"La date de fin du contrat doit être postérieure à la date du début \n";
              }
          }*/

          if (data.collaborateur.length) {
            for (let dateCon of data.collaborateur) {
              date1 = new Date(dateCon.dd);
              date2 = new Date(dateCon.df);
              if (date1 > date2 && (date2 != undefined || date2 != null)) {
                this.temp = this.temp+"La date de fin du contrat doit être postérieure à la date du début";
              }
            }
          } 

          if (data.collaborateur.length) {
            for (let i = 0; i < data.collaborateur.length; i++) {
              for (let j = i + 1 ; j < data.collaborateur.length; j++) {
                date3 = new Date(data.collaborateur[i].df);
                date4 = new Date(data.collaborateur[j].dd);
              if (date3 >= date4 && (date4 != undefined || date4 != null)) {
                this.temp = this.temp+"La date de début de chaque contrat doit être strictement postérieure à la date de fin du contrat précédent";
              }
              
              }
            }
          }


          //Ajouter toutes les conditions succeptibles de génerer des erreurs
          if((data.fe.experience < 0) ||
            ((data.collaborateur.length) && (date1 > date2 && (date2 != undefined || date2 != null)))||
            //((data.collaborateur.length && data.collaborateur.length == 1) && ( data.collaborateur[0].dd > data.collaborateur[0].df && (data.collaborateur[0].df != undefined || data.collaborateur[0].df != null))) || 
            ((data.collaborateur.length) && (date3  >= date4 && (date4 != undefined || date4 != null)))||
            ( data.diplomes[data.diplomes.length -1] != undefined &&  data.diplomes[data.diplomes.length -1].annee < 1900) ||
            (data.dcs[indexOfSelected].certifs[data.dcs[indexOfSelected].certifs.length -1] != undefined) && data.dcs[indexOfSelected].certifs[data.dcs[indexOfSelected].certifs.length -1].date < 1900 ||
            d1 > d2){
            alert(this.temp);
            //this.errorMessage = "Formulaire invalide ";
            this.showSpinner = false;
            //this.MsgError = this.errorMessage;
            //window.scrollTo(0, 0);
            this.temp = '';
           // this.resetErrorMessage();
          }
          else{
            this.success(data)
          }

        },
        error => {
          this.showSpinner = false;
          this._notifyService.showError("Erreur de mise à jour", "Update", 3000)
          /*this.errorMessage = "Erreur de mise à jour";
          this.MsgError = error.message;
          this.resetErrorMessage();*/
        }
      );
  }else{
    this._notifyService.showError("Formulaire invalide", "Update", 3000)
    /*this.errorMessage = "Formulaire invalide ";
    this.MsgError = this.errorMessage;
    window.scrollTo(0, 0);
    this.resetErrorMessage();*/
  }
}

success(data){
  this.editForm = false;
  this.fillDossierInView(data);
  this._notifyService.showSuccess("Le dossier a été mis à jour", "Update", 3000)
  //this.successMessage = 'Le dossier a été mis à jour';
  //window.scrollTo(0, 0);
  this.justUpdated = data._id;
  //this.resetSuccesMessage();
}

//Ajouter une évaluation avec par défaut le prénom du manager connecté
addEval(){
    let newEval = new Eval();
    newEval.manager = this.defaultManager;
    this.evals.push(newEval);
  }

//Supprimer une évaluation
deleteEval(index){
  if(index > 0)
    this.evals.splice(index,1);
  else
    alert('Au minimum une évaluation');
}

  // ============= Gestion des dossier de competences ============

  // Générer le cv pdf pour le dossier de compétences sélectionné
  generatePDF(){
    let params = {
      dossierId : this.dossier._id,
      dcId : this.selectedDC
    };
    this.showSpinner = true;
    this.dossierService.generatePDF(environment.generatePDFUrl, params , true, environment.contentTypes.json)
      .subscribe(
        data => {
          console.log(saveAs(data,this.getDCFileName()))
           saveAs(data,this.getDCFileName());

            this.showSpinner = false;
            this._notifyService.showSuccess("Document sauvegardé", "Generate PDF", 3000)
            /*this.successMessage = 'Document sauvegardé';
            this.resetSuccesMessage();*/
        },
      error => {
        this.showSpinner = false;
        this._notifyService.showError("Erreur de sauvegarde du document", "Generate PDF", 3000)
        /*this.errorMessage = "Erreur de sauvegarde du document";
        this.MsgError = error.message;
        this.resetErrorMessage();*/
      }
    );
  }

  getDCFileName(): string{
      let dcName = this.general.prenom.substring(0,2) + this.general.nom.substring(0,2);
      return "DC_WELL'D_"+dcName.toUpperCase()+".pdf";
  }

  // remplir les champs du dossier de competance courant par celui selectionné
  fillCurrentDC(){
    let selId = this.selectedDC;
    let selected = _.find(this.dcs, function(d){ return ( d._id == selId);});
    this.certifs = selected.certifs;
    this.currentDc = selected;

    this.skills = selected.skills;
    for(let j=0;j<selected.skills.length;j++){
      this.dskillsTags[j] = this.mapStringToTags(selected.skills[j].dskills);
    }
    this.experiences = selected.experience;
    if(this.experiences != undefined){
      for(let exp of this.experiences){
        exp.from = this.formatDateForDisplay(exp.from);
        exp.to = this.formatDateForDisplay(exp.to);
      }
    }
    // titre + resume
    this.resume = selected.resume;
    this.titre = selected.titre;
  }

  // mettre a jour le dossier courant dans la liste des dossiers
  saveCurrentDC(){
    let indexOfSelected = 0;
    if(this.dcs.length > 0 && this.dcs != undefined){
      let selId = this.selectedDC;
      let selected = _.find(this.dcs, function(d){ return ( d._id == selId);});
      indexOfSelected = _.findIndex(this.dcs, function(d){ return d._id == selId});
      this.currentDc = selected;
    }else{
        let dc = new Dc();
        dc.manager = this._authService.getAuthenticatedUser();
        dc.date = Date();
        this.dcs.push(dc);
      }

      // experience
      if(this.experiences != undefined){
        this.dcs[indexOfSelected].experience = this.experiences;
      }
      // skills
      for(let i=0;i<this.skills.length;i++){
          this.skills[i].dskills = this.mapTagsToString(this.dskillsTags[i]);
        }
      this.dcs[indexOfSelected].skills = this.skills;
      // certifs
      this.dcs[indexOfSelected].certifs = this.certifs;
      // titre et resume
      this.dcs[indexOfSelected].titre = this.titre;
      this.dcs[indexOfSelected].resume = this.resume;

    }

    // ajouter une novelle experience
    addExperience(){
      let newExperience = new Experience();
      this.experiences.push(newExperience);
    }
    // supprimer une experience
    deleteExperience(index){
      this.experiences.splice(index,1);
    }

     // ajouter un nouveau diplome
     addDiplome(){
      let newDiplome = new Diplome();
      this.diplomes.push(newDiplome);
    }
    // supprimer un diplome
    deleteDiplome(index){
      this.diplomes.splice(index,1);
    }

    // ajouter un nouveau contrat
    addNewContrat(dernierContrat){
      let newContrat= new Collaborateur();
      //La date de début d'un nouveau contrat devrait d'être initialisée à la date Max entre "Aujourd'hui" et la date de fin du contrat précédent
      let date = new Date().toLocaleDateString('pt-PT');
      let dateNow = new Date(this.reformatDate2(date));
      let dateFinDernierContrat = new Date(dernierContrat.df);

      if(dateFinDernierContrat > dateNow){
        let addOneDay = dateFinDernierContrat.setDate(dateFinDernierContrat.getDate() + 1)
        let newddContrat = new Date(addOneDay).toLocaleDateString('pt-PT')
        newContrat.dd = this.reformatDate2(newddContrat);
      }
    
      this.collaborateur.push(newContrat);
    }

    // supprimer un contrat
    deleteContrat(index: number){
      if(confirm( "Voulez vous vraiment supprimer ce contrat ?") ){
        this.collaborateur.splice(index,1);
        this.update(true);
        this.reloadPage();
      }
    }


  //FONCTION POUR LA MISE A JOUR DES MISSIONS
  addMission(){
    if(confirm("Voulez vous vraiment créer une nouvelle mission ?")){
      let mission = new Mission();
      if(this.missions.length == 0){
        mission.idMission = 1;
      }else{
        mission.idMission = this.missions[this.missions.length - 1].idMission + 1
      }
      this.missions.push(mission);
      this.update(true);
    }
  }

  //Récuperer l'indentifiant d'une mission
  getIdMission(idMission : number){
    this.idmission  = idMission;
  }
  
      
  isValidatedMissionChanged(isChecked : Boolean){
    this.toValidateChecked = isChecked;
  }
      
//Supprimer une mission de la liste des missions
deleteMission(index: number){
  if(confirm("Voulez vous vraiment supprimer cette mission ?")){
    this.missions.slice(index,1)
  }
}
   





    // ajouoter un nouveau domaine de compétences
    addDomaine(){
      let newSkill = new Skill();
      this.skills.push(newSkill);
    }

    // supprimer un domaine de compétences
    deleteDomaine(index){
      this.skills.splice(index,1);
    }

    // ajouter une nouvelle certification
    addCertif(){
      let newCertif = new Certif();
      this.certifs.push(newCertif);
    }

    // supprimer un certification
    deleteCertif(index: number){
      this.certifs.splice(index,1);
    }
    // ajouter une langue
    addLangue(){
      let newLangue = new Langue();
      this.langues.push(newLangue);
    }
    //Supprimer une langue
    deleteLangue(index: number){
        this.langues.splice(index,1);
    }

      // Map liste of tags to string
    mapTagsToString(tags){
      let str : String = '';
      for(let tag of tags){
        str+=tag.value+';';
      }
      return str;
    }

    //Calculer le nombre de mois entre deux dates (2021-10-04 et 2020-12-15)
    diffInMonths(d1: any, d2: any): number{
      var firstDate  = new Date(d1);
      var secondDate  = new Date(d2);
      var fm = firstDate.getMonth();
      var fy = firstDate.getFullYear();
      var sm = secondDate.getMonth();
      var sy = secondDate.getFullYear();
      var months = Math.abs(((fy - sy) * 12) + fm - sm);
      var firstBefore = firstDate > secondDate;
      firstDate.setFullYear(sy);
      firstDate.setMonth(sm);
      firstBefore ? firstDate < secondDate ? months-- : "" : secondDate < firstDate ? months-- : "";
      return months;
  }

  //Afficher les dates au format JJ/MM/AAAA
   reformatDate(dateStr){
    return dateStr.toString().split("-").reverse().join("/");
  }

  //Afficher les dates au format JJ-MM-AAAA
  reformatDate2(dateStr){
    return dateStr.toString().split("/").reverse().join("-");
  }
  

    
    //FONCTION PERMETTANT DE METTRE À JOUR LE BILAN ANNUEL EN FONCTION DES MISSIONS EN COURS OU DÉJÀ TERMINÉES
    addBilanAnnuel(){
      if(confirm( "Voulez vous vraiment initier le bilan pour cette année ?")){
        let bilanAnnuel = new BilanAnnuel();
        var projets : Projet[] = [];
        bilanAnnuel.projets = projets;
        var perspecEtSouhaits : PerspecEtSouhait[] = [];
        var year = new Date()
        let dateNow = year.getFullYear()+"-"+(year.getMonth()+1)+"-"+year.getDate();
        let perspecEtSouhait = new PerspecEtSouhait();
      if(this.bilansAnnuels.length == 0){
        bilanAnnuel.annee = parseInt(this.formatDateForDisplayYear(this.dernierContrat.dd)) + 1;
        
      }else{
        bilanAnnuel.annee = this.bilansAnnuels[this.bilansAnnuels.length - 1].annee + 1;
        
      }
      bilanAnnuel.fonctionActuelle = this.missions[this.missions.length - 1].poste;
      bilanAnnuel.occupeDepuis = this.formatDateForDisplay(this.missions[this.missions.length - 1].debutMission);
      
      
      //Initier les Projets avec les missions réalisées
      for( let m = 0; m < this.missions.length; m++){
        let projet = new Projet();
        if( ( parseInt(this.formatDateForDisplayYear(this.missions[m].debutMission))  ==  (bilanAnnuel.annee - 1) )  && ( parseInt(this.formatDateForDisplayYear(this.missions[m].finMission)) ==  (bilanAnnuel.annee - 1) ) ){
          projet.posteOccupe = 'A travaillé en tant que  ' + this.missions[m].poste +  ' chez ' + this.missions[m].client  +  ' de ' + this.reformatDate(this.missions[m].debutMission) + ' à ' + this.reformatDate(this.missions[m].finMission);
          projet.nbreMois =  this.diffInMonths(this.missions[m].finMission, this.missions[m].debutMission);
          projets.push(projet)
        }
        if( ( parseInt(this.formatDateForDisplayYear(this.missions[m].debutMission)) ==  (bilanAnnuel.annee - 1) )  && (this.missions[m].finMission == undefined )){
          projet.posteOccupe = 'Travaille actuellement en tant que ' + this.missions[m].poste +  ' chez ' + this.missions[m].client + ' depuis le ' + this.reformatDate(this.missions[m].debutMission); 
          projet.nbreMois =  this.diffInMonths(dateNow, this.missions[m].debutMission); 
          projets.push(projet)
        }
        if( ( parseInt(this.formatDateForDisplayYear(this.missions[m].debutMission)) < (bilanAnnuel.annee - 1) ) && this.missions[m].finMission == undefined){
          projet.posteOccupe = 'Travaille actuellement en tant que ' + this.missions[m].poste +  ' chez ' + this.missions[m].client + ' depuis le ' + this.reformatDate(this.missions[m].debutMission); 
          projet.nbreMois = this.diffInMonths(dateNow, this.missions[m].debutMission);
          projets.push(projet)
        }
        if( ( parseInt(this.formatDateForDisplayYear(this.missions[m].debutMission)) < (bilanAnnuel.annee - 1) ) && ( parseInt(this.formatDateForDisplayYear(this.missions[m].finMission)) == (bilanAnnuel.annee - 1) )  ){
          projet.posteOccupe = 'A travaillé en tant que  ' + this.missions[m].poste +  ' chez ' + this.missions[m].client  +  ' de ' + this.reformatDate(this.missions[m].debutMission) + ' à ' + this.reformatDate(this.missions[m].finMission);
          projet.nbreMois = this.diffInMonths(this.missions[m].finMission, this.missions[m].debutMission);
          projets.push(projet)
        }
      }

      bilanAnnuel.projets = projets;
      bilanAnnuel.collaborateur = this.general.prenom + ' ' + this.general.nom;
      if(this.fe.experience != undefined){
        bilanAnnuel.nombreAnneeExp = (this.fe.experience + (year.getFullYear() - parseInt(this.formatDateForDisplayYear(this.actions.evals[this.actions.evals.length - 1].date) )) );
      }else{
        bilanAnnuel.nombreAnneeExp =  (year.getFullYear() - parseInt(this.formatDateForDisplayYear(this.actions.evals[this.actions.evals.length - 1].date) ));
      }
      bilanAnnuel.dateEntreeCdiWelld = this.formatDateForDisplay(this.dernierContrat.dd);
      bilanAnnuel.responsableActuelle = this.dernierContrat.responsable;
      bilanAnnuel.perspecEtSouhaits = perspecEtSouhaits;
      bilanAnnuel.perspecEtSouhaits.push(perspecEtSouhait);
      this.bilansAnnuels.push(bilanAnnuel);
      this.update(true);
    }
  }
    //Ajouter un projet dans le BA
    addProjet(bilan : BilanAnnuel){
      let projet = new Projet();
      bilan.projets.push(projet);
    }
    validationBilanChanged(isChecked : boolean){
      if(isChecked){
        this._notifyService.showWarning("N'oubliez pas de cliquer sur le bouton de mise à jour en bas à gauche de l'écran", "Valider le bilan", 10000);
      }else{
        
      }
    }

    //Validation du bilan annuel
    isValidationBAChecked(checked){
      return checked;
    }

    //Ajouter un souhait dans  dans le BA par le collaborateur
    addSouhait(bilan : BilanAnnuel){
      let perspecEtSouhait = new PerspecEtSouhait()
      bilan.perspecEtSouhaits.push(perspecEtSouhait);
    }
    // récupérer l'année du bilan à afficher pour voir les détails
    getAnnee(annee : number){
      this.anneeBilan = annee;
    }
    // formatage de la date pour récupérer uniquement l'année
   formatDateForDisplayYear(date: any){
    if(date != undefined)
      return date.substr(0, 4);
  }

    deleteSouhait(bilan : BilanAnnuel, idSouhait : number){
      if(idSouhait > 0){
        bilan.perspecEtSouhaits.splice(idSouhait,1)
      }else{
        alert('Au minimum un souhait');
      }
    }



  // map string from db to tags table format
  mapStringToTags(str){
    let items  = str.split(";");
    items.pop();
    let tags : any[] =  [];
    for(let i=0;i<items.length;i++){
      let tag = new Tag();
      tag.value = items[i];
      tag.display = items[i];

      tags.push(tag);
      //tags[i].display = items[i];
    }
    return tags;
  }

  // copier le dossier de competence courant :

  copyDC(){
    let selId = this.selectedDC;
    let indexOfSelected = _.findIndex(this.dcs, function(d){ return d._id == selId});
    let selected = _.find(this.dcs, function(d){ return ( d._id == selId);});
    this.selectedDC = this.dcs[indexOfSelected]._id;

    let newDC = loadDash.cloneDeep(selected);
    delete newDC._id;
    newDC.manager = this._authService.getAuthenticatedUser();
    newDC.date = Date();
    this.dcs.push(newDC);
    this.update(true);
  }


  // formatage des dates
   formatDateForDisplay(date){
    if(date != undefined)
      return date.substr(0,10);
  }

  currentExpChanged(actual){
    this.currentExpChecked = actual;
  }

  permisChanged(actual){
    this.permisChecked = actual;
  }

  retardChanged(actual){
    this.retardChecked = actual;
  }
  validationChanged(isChecked : Boolean){
    this.validationChecked = isChecked;
  }

  

  // Passer le candidat en collaborateur
  passerConsultant(){
    this.isCollaborateur = true;
  }
  //Vider les messages d'erreur et de succès
  /*clearMessages(){
    this.errorMessage = '';
    this.successMessage = '';
  }*/
  //Téléchargement des fichiers
  uploadFile(form: NgForm){
    const typefile = form.value['fileType'];
    if(this.filesToUpload.length > 0 ){
      this.showSpinner = true;
      const formData: any = new FormData();
      const files: Array<File> = this.filesToUpload;
      for(let f of this.filesToUpload){
        formData.append("uploads[]", f, typefile + " -- " + f['name']);
      }
      this.dossierService.uploadFiles(formData, this.dossier._id).subscribe(
        data => {
          this._notifyService.showSuccess("Fichier uploadé", " Upload file", 3000)
          //this.successMessage = "Fichier uploadé";
          this.showSpinner = false;
          this.fillDossierInView(data);
          this.filesToUpload = [];
          this.file = '';
          this.fileType = '';
          //this.resetSuccesMessage();
        },
        error => {
          this._notifyService.showError("Erreur upload fichiers", " Upload file", 3000)
          //this.errorMessage = "Erreur upload fichiers"
          this.showSpinner = false;
          //this.MsgError = error.message;
          //this.resetErrorMessage();
        });
    }else{
      alert("Veuillez sélectionner un fichier");
    }
    this.update(true);
  }

  //Uploader un fichier dans le bilan annuel
  uploadFileBilanAnnuel(idBilan: number){
    if(this.fileToUploadBA.length > 0 ){
      this.showSpinner = true;
      const formData: any = new FormData();
      const files: Array<File> = this.fileToUploadBA;
      for(let f of this.fileToUploadBA){
        formData.append("uploads[]", f, f['name']);
      }
      this.dossierService.uploadFileBilanAnnuel(formData, this.dossier._id, idBilan).subscribe(
        data => {
          this._notifyService.showSuccess("Fichier uploadé", " Upload file", 3000)
          //this.successMessage = "Fichier uploadé";
          this.showSpinner = false;
          this.fillDossierInView(data);
          this.fileToUploadBA = [];
          this.fileBA= '';
          
        },
        error => {
          this._notifyService.showError("Veuillez sélectionner un fichier de type PDF ou EXCEL", " Erreur file", 3000)
          this.showSpinner = false;
          
        });
    }else{
      alert("Veuillez sélectionner un fichier");
    }
    this.update(true);
  }

  //Supprimer le fichier dans le Bilan annuel
  deleteFileBilanAnnuel(fileName, idBilan){
    this.dossierService.deleteFileBilanAnnuel(this.dossier._id, fileName, idBilan)
    .subscribe(
      data => {
        this.fillDossierInView(data);
        this.update(true);
      },
      error => {
        this._notifyService.showError("Erreur de suppression du fichier", "Delete file", 3000)
      }
    );
  }

  uploadCVFile(){
    if(this.cvFileToUpload.length > 0 ){
      this.showSpinner = true;
      const formData: any = new FormData();
      const files: Array<File> = this.cvFileToUpload;
      for(let f of this.cvFileToUpload){
        formData.append("uploads[]", f, f['name']);
      }

      this.dossierService.uploadCVFiles(formData, this.dossier._id).subscribe(
        data => {
            this._notifyService.showSuccess("Fichiers uploadés", " Upload CV", 3000)
            //this.successMessage = "Fichiers uploadés";
            //this.MsgError='';
            this.showSpinner = false;
            this.fillDossierInView(data);
            //this.filesToUpload = [];
            this.cvFileToUpload = [];
            this.fileCV = '';
            //this.file = '';
            //this.resetSuccesMessage();
        },
        error => {
          // donner la possibilité de faire l'upload de deux types de fichiers
          if(this.cvFileToUpload[0].type != 'application/pdf' ||
            this.cvFileToUpload[0].type != 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'){
              alert("Veuillez sélectionner un fichier de type PDF ou DOCX");
              this._notifyService.showError("Type de fichier invalide", "Upload CV", 3000)
              //this.errorMessage = "Type de fichier invalide ";
              //this.successMessage='';
              this.fileCV = '';
              this.showSpinner = false;
              //this.MsgError = this.errorMessage;
              //window.scrollTo(0, 0);
              //this.resetErrorMessage();
          }else{
          this._notifyService.showError("Erreur upload fichiers", "Upload CV", 3000)
          //this.errorMessage = "Erreur upload fichiers"
          //this.successMessage='';
          this.showSpinner = false;
          //this.MsgError = error.message;
          //this.resetErrorMessage();
          }
        });
    }else{
      alert("Veuillez sélectionner un fichier");
    }
    this.update(true);
  }
  //Téléchargement des fichiers
  viewFile(fileName){
    this.dossierService.downloadFile(this.dossier._id, fileName)
    .subscribe(
      data => {
          var reader = new FileReader();
          reader.readAsDataURL(data as Blob); // read file as data url
          reader.onload = (event) => { // called once readAsDataURL is completed
          this.url = reader.result;
          this.trustedURL = this.sanitizer.bypassSecurityTrustResourceUrl(this.url);          
        }
          this.showSpinner = false;
        },
        error => {
          this.showSpinner = false;
          this._notifyService.showError("error de consultation du fichier", "View file", 3000)
          /*this.errorMessage = "error de consultation du fichier";
          this.MsgError = error.message;*/
        }
    )
  }

  getFileExtension(filename) {
    return filename.split('.').pop();
}
  /**
   * Download a file
   * @param fileName
   */
  downloadFile(fileName){
    this.dossierService.downloadFile(this.dossier._id, fileName)
    .subscribe(
      data => {
          saveAs(data,fileName);
          this.showSpinner = false;
          this._notifyService.showSuccess("Document téléchargé", "Download File", 3000)
          /*this.successMessage = 'Document téléchargé'
          this.resetSuccesMessage();*/
          },
        error => {
          this.showSpinner = false;
          this._notifyService.showError("Error while downloading file", "Download File", 3000)
          /*this.errorMessage = "error while downloading file";
          this.MsgError = error.message;
          this.resetErrorMessage();*/
        }
    );
  }
  //Supprimer un fichier téléchargé
  deleteFile(fileName){
    this.dossierService.deleteFile(this.dossier._id, fileName)
    .subscribe(
      data => {
        this.fillDossierInView(data);
      },
      error => {
        this._notifyService.showError("Erreur de suppression du fichier", "Delete file", 3000)
        /*this.errorMessage = "Erreur de suppression du fichier";
        this.MsgError = error.message;
        this.resetErrorMessage();*/
      }
    );
  }

  //Supprimer un CV téléchargé
  deleteCVFile(fileName){
    this.dossierService.deleteCVFile(this.dossier._id, fileName)
    .subscribe(
      data => {
        data.general.cvBrut = '';
        this.fillDossierInView(data);
        this.update(true);
      },
      error => {
        this._notifyService.showError("Erreur de suppression du fichier", "Delete CV", 3000)
        /*this.errorMessage = "Erreur de suppression du fichier";
        this.MsgError = error.message;
        this.resetErrorMessage();*/
      }
    );
  }

 

  isChecked(di,st){
    if(st != undefined)
    return st.indexOf(di)>=0;
  }
  isValidationChecked(checked){
    return checked;
  }
 
  isRefChecked(checked){
    return checked;
  }

  deleteCopie(current){
    this.dcs = this.dcs.filter(item => item._id !== current._id);
    this.currentDc = this.dcs[0];
    this.selectedDC = this.currentDc._id;
    this.titre = this.dcs[0].titre;
    this.experiences =  this.dcs[0].experience;
    this.skills =  this.dcs[0].skills;
  }

  provenanceChanged(pr,actual){
    for(let p in this.provenances){
      if( p != pr){
        ///Rénitialiser si la provenance à changer (passer de coptation)
        delete this.fe.details;
        delete this.fe.coptationIsValided;
      }
    }

  }

  //Vérifier si la coptation à coché ou pas.
  isCoptationChecked(checked: any){
    return checked;
  }

  coptationChanged(isChecked : Boolean){
    this.coptationIsChecked = isChecked;
  }


  reloadPage(){
    setTimeout(()=>{
      window.location.reload();
    }, 4000);
  } 

 /* resetErrorMessage(){
    setTimeout(()=>{
      this.MsgError = '';
    }, 3000);
  }

  resetSuccesMessage(){
    setTimeout(()=>{
      this.justUpdated = '';
    }, 3000);
  }
*/
  // la Mise à jour automatique de la fiche d'entretien au bout d'une minute si le click n'est pas déclenché
  onSearchChange(searchValue: string): void {
    if(searchValue != ''){
      this.editForm = true;
    }else{
      this.editForm = false;
    }
  }

}

/*      setTimeout(() => {
        this.update(true)
      }, 60000);*/



// WEBPACK FOOTER //
// ./src/app/dossier-details/dossier-details.component.ts